// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3H49v","content":"styles_content__1yIja","checkbox":"styles_checkbox__3cpL4","checkboxLabel":"styles_checkboxLabel__22j50"};